module.exports = __webpack_public_path__ + "static/media/chat.bd3a6fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferingImages/assets/chat.png
// module id = 491
// module chunks = 0